export const RATING_PRECISION_FLOOR = 4.61;
export const RATING_PRECISION_CEILING = 5;
export const FULL_SCORE_EXCEPTIONS = [4.7, 4.8, 4.9, 5.0];
